export function initializeBackgroundVideos() {
  const loadVideos = () => {
    if (!window.matchMedia('(min-width: 768px)').matches) return;

    document.querySelectorAll('.video-foreground iframe[data-src]').forEach((iframe) => {
      // `iframe.src` is a resolved browser property, not a reliable indicator
      // of whether this lazy-loaded iframe has a `src` attribute yet.
      if (!iframe.hasAttribute('src')) {
        iframe.setAttribute('src', iframe.dataset.src);
      }
    });
  };

  loadVideos();
  window.addEventListener('resize', loadVideos, { passive: true });
}
